import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';

import { SideNavComponent } from '@shared/side-nav/side-nav.component';

@Component({
  selector: 'mojo-side-nav-filter',
  templateUrl: './side-nav-filter.component.html',
  styleUrls: ['./side-nav-filter.component.scss'],
})
export class SideNavFilterComponent {
  @Input() totalResults: number;
  @Input() opened: boolean;
  @Output() closed = new EventEmitter();
  @Output() wentBack = new EventEmitter();
  @Output() showResult = new EventEmitter();
  @Output() clearFilters = new EventEmitter();

  @ViewChild('sidenav') sidenav: SideNavComponent;

  constructor() {}

  goBack() {
    this.wentBack.emit();
    this.close();
  }

  close() {
    this.closed.emit();
  }

  onShowResult() {
    this.sidenav.close();
    this.showResult.emit();
  }

  onClearFilters() {
    this.sidenav.close();
    this.clearFilters.emit();
  }
}
